<!-- Standalone console: this page sits outside the tenant layout, so it carries its
     own slim header (and the only way out, logout). -->
<div class="sa-shell">

  <header class="sa-header">
    <div class="sa-brand">
      <span class="sa-title">{{ projectTitle }}</span>
      <span class="sa-scope">Platform administration</span>
    </div>
    <button mat-stroked-button type="button" (click)="logout()">
      <i-tabler name="logout" class="icon-18 m-r-4"></i-tabler>
      Logout
    </button>
  </header>

  <mat-card class="cardWithShadow">
    <mat-card-content class="p-24">
      <div class="row justify-content-between align-items-center">
        <div class="col-lg-4">
          <mat-form-field appearance="outline" class="w-100 hide-hint">
            <input matInput placeholder="Search hospital" [formControl]="searchControl" />
            <mat-icon matSuffix>
              <i-tabler name="search" class="icon-20"></i-tabler>
            </mat-icon>
          </mat-form-field>
        </div>
        <div class="col-lg-4 d-flex align-items-center justify-content-end">
          <button mat-flat-button color="primary" (click)="addHospital()">
            <mat-icon>add</mat-icon>
            Add Hospital
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="cardWithShadow">
    <mat-card-content class="p-24">

      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="w-100">

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">Hospital</th>
            <td mat-cell *matCellDef="let hospital">
              <p class="f-w-600 mat-subtitle-1 f-s-15 m-y-0">{{ hospital.name }}</p>
            </td>
          </ng-container>

          <ng-container matColumnDef="registrationNumber">
            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">Registration No</th>
            <td mat-cell *matCellDef="let hospital" class="f-s-14">
              {{ hospital.registrationNumber }}
            </td>
          </ng-container>

          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">City</th>
            <td mat-cell *matCellDef="let hospital" class="f-s-14">
              {{ hospital.city }}<span *ngIf="hospital.state">, {{ hospital.state }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="mobile">
            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">Contact</th>
            <td mat-cell *matCellDef="let hospital" class="f-s-14">
              {{ hospital.mobile || hospital.phone }}
            </td>
          </ng-container>

          <ng-container matColumnDef="documentActions">
            <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">Legacy documents</th>
            <td mat-cell *matCellDef="let hospital">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  [disabled]="isAnyDocumentOperationRunning"
                  (click)="confirmLegacyDocumentCopy(hospital)">
                  <mat-spinner
                    *ngIf="isDocumentOperationRunning(hospital.id, 'copy')"
                    diameter="16">
                  </mat-spinner>
                  <mat-icon *ngIf="!isDocumentOperationRunning(hospital.id, 'copy')">content_copy</mat-icon>
                  Copy
                </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <div class="sa-empty" *ngIf="!isLoading && dataSource.data.length === 0">
          No hospitals yet. Use Add Hospital to onboard the first one.
        </div>
      </div>

      <mat-paginator
        *ngIf="pagination"
        [length]="pagination.rowCount"
        [pageSize]="pagination.pageSize"
        [pageIndex]="pagination.currentPage"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPageChange($event)">
      </mat-paginator>

      <section class="sa-document-result" *ngIf="documentOperationResult as result" aria-live="polite">
        <div class="sa-result-heading">{{ result.title }} — {{ result.hospitalName }}</div>

        <div class="sa-result-stats">
          <span>Found: {{ result.found }}</span>
          <span>Copied: {{ result.completed }}</span>
          <span>Missing: {{ result.missing }}</span>
          <span>Failed: {{ result.failed }}</span>
        </div>

        <div class="sa-result-errors" *ngIf="result.errors.length > 0">
          <strong>Missing and failed document log</strong>
          <ul>
            <li *ngFor="let error of result.errors">{{ error }}</li>
          </ul>
        </div>
      </section>
    </mat-card-content>
  </mat-card>

</div>
